import { IExtensionsSiteSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetExtensionsSiteSettingsParams {
  // this is needed to support guest session in vizclient
  // should be empty if user is authenticated
  path: string;
}

export type IGetExtensionsSiteSettingsResult = IResult & IExtensionsSiteSettings;

export class GetExtensionsSiteSettingsRequest extends Request<IGetExtensionsSiteSettingsParams, IGetExtensionsSiteSettingsResult> {
  constructor(params: IGetExtensionsSiteSettingsParams) {
    super('getExtensionsSiteSettings', params);
  }
}
